/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 15.10.2016.
 */

import React, {Component} from 'react';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    if (!Config.footer) {

      return null;
    }

    return (
      <div className="ui inverted menu-top block bg-black radius mb" style={{overflow: 'initial', width: '100%', marginTop: '50px'}}>
        <span className="item ph mh"></span>
        {Config.footer.menu.map((item, index) => {

          return <a key={'item_' + index} className="item" href={item.url} target="_blank">{item.title}</a>;
        })}

        {Config.footer.copyright && <div className="right menu-top">
          <span className="item" href="javascript:void(0)">{Config.footer.copyright}</span>
          <span className="item ph mh"></span>
        </div>}
      </div>)
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer/footer.js